import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

const CancelScheduleConfirmationModal = (props) => {
  const { enableModal, onClose, onCancelSchedule } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title='Cancel scheduled publication?' onClose={onClose} />
      <ModalBody>If you cancel, you can still reschedule or immediately publish this article.</ModalBody>
      <ModalFooter>
        <ButtonControl title='Confirm' variant='danger' onClick={onCancelSchedule} class='qa-cancel-confirm' />
        <ButtonControl title='Cancel' onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export default CancelScheduleConfirmationModal
